import React from "react";
import InterviewNotExist from "./InterviewNotExist";

const InvalidInterviewLink = () => {
    return (
        <div style={{display: "flex", height: '100vh', justifyContent: 'center', alignItems: 'center', textAlign: 'center'}} >
            <InterviewNotExist />
        </div>
    )
}


export default InvalidInterviewLink;